import { createFileRoute } from '@tanstack/react-router';
import { LandingPage } from '@/components/marketing/pages/LandingPage';

export const Route = createFileRoute('/_marketing/')({
  component: LandingPage,
});
